import { yupResolver } from '@hookform/resolvers/yup';
import React, { useState } from 'react';
import { useForm } from 'react-hook-form';
import { useNavigate } from 'react-router-dom';
import * as yup from 'yup';

import Button from '../../components/button/Button';
import Input from '../../components/input/Input';
import { useAppDispatch } from '../../hooks/store';
import { successMessage } from '../../hooks/useNotifications';
import { impersonateThunk, validateImpersonationThunk } from '../../redux/reducer/propSlice';
import { withErrorHandler } from '../../utils/utils';
import NotFound from '../NotFound';

const loginSchema = yup.object().shape({
  email: yup.string().required('POC Email is required'),
  domain: yup.string().required('Domain is required')
});

const otpSchema = loginSchema.shape({
  otp: yup.string().required('OTP is required')
});

type LoginFormData = yup.InferType<typeof loginSchema>;
type OtpFormData = yup.InferType<typeof otpSchema>;
type FormData = LoginFormData | OtpFormData;

export const AdminLogin: React.FC = () => {
  const [otpSend, setOtpSend] = useState<boolean>(false);
  const dispatch = useAppDispatch();
  const navigate = useNavigate();
  const {
    register,
    handleSubmit,
    formState: { errors, isSubmitting }
  } = useForm<FormData>({
    resolver: yupResolver(otpSend ? otpSchema : loginSchema)
  });

  const isEnabled = localStorage.getItem('isAdminLoginEnabled');
  if (!isEnabled || isEnabled !== 'true') {
    return <NotFound />;
  }

  const onSubmit = (data: FormData) =>
    withErrorHandler(async () => {
      if (otpSend) {
        await dispatch(impersonateThunk(data as OtpFormData)).unwrap();
        navigate('/products');
      } else {
        await dispatch(validateImpersonationThunk(data as LoginFormData)).unwrap();
        successMessage('OTP Send to your email ID');
        setOtpSend(true);
      }
    });

  const commonProps = {
    register,
    errors,
    topLabel: true,
    required: true,
    className: `bg-gray-200 rounded-md px-2 font-medium text-black`
  };

  return (
    <div className="flex flex-col justify-center items-center">
      <h1 className="m-8 font-bold text-2xl">Please Enter your Details</h1>
      <form onSubmit={handleSubmit(onSubmit)} className="space-y-4">
        <Input {...commonProps} label="POC Email" type="text" name="email" />
        <Input {...commonProps} label="Client Domain" type="text" name="domain" />
        {otpSend && <Input {...commonProps} label="OTP" type="text" name="otp" />}

        <Button label={otpSend ? 'Login' : 'Get OTP'} isLoading={isSubmitting} className="py-2 px-4" />
      </form>
    </div>
  );
};
